/* Black Hour: Shopify-native cart actions, independent of Instant.api. */
(function () {
  if (window.BlackHourCart) return;
  function errorText(data) {
    if (data && typeof data.description === 'string') return data.description;
    if (data && typeof data.message === 'string') return data.message;
    return 'Could not add this item. Please try again.';
  }
  async function add(ids, button) {
    const valid = (Array.isArray(ids) ? ids : [ids]).map(Number);
    if (!valid.length || valid.some(function (id) { return !Number.isSafeInteger(id) || id <= 0; })) {
      window.alert('Please choose a product option first.');
      return;
    }
    if (button && button.disabled) return;
    const text = button ? button.textContent : '';
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    try {
      const response = await fetch(window.BlackHourRoutes.add, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({items: valid.map(function(id){return {id: id, quantity: 1};})})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(errorText(data));
      window.location.assign(window.BlackHourRoutes.cart);
    } catch (err) {
      window.alert(err.message || 'Cart unavailable. Please try again.');
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = text; }
    }
  }
  window.BlackHourCart = {add: add, open: function () { window.location.assign(window.BlackHourRoutes.cart); }};
})();
